import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from 'react-jsonschema-form';
import { isEmpty } from 'lodash';
import { Button } from 'reactstrap';

import Spin from 'components/ui/Spin';
import FormProcessor from '../../../core/forms/form-processor';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  schema: PropTypes.object.isRequired,
  uiSchema: PropTypes.object,
  formData: PropTypes.object,
  isEditing: PropTypes.bool.isRequired,
};

class StateFields extends Component {
  constructor(props) {
    super(props);

    this.formProcessor = new FormProcessor();
    this.handleChange = this.handleChange.bind(this);

    this.state = {
      markAsComplete: false,
    };
  }

  componentWillReceiveProps({ formData, schema, uiSchema }) {
    const initialState = this.formProcessor.run({
      initialSchema: schema,
      initialUiSchema: uiSchema,
      schema,
      uiSchema,
      formData,
    });

    this.setState(initialState);
  }

  handleChange({ formData }) {
    const { schema, uiSchema } = this.state;

    const newState = this.formProcessor.run({
      schema,
      uiSchema,
      formData,
    });

    this.setState(newState);
  };

  handleSubmit = ({ formData }) => {
    this.props.onSubmit({ form_data: formData }, this.state.markAsComplete);
  };

  handleCompletedSubmit = (event) => {
    event.preventDefault();
    this.setState({ markAsComplete: true }, () => {
      this.submitButton.click();
    });
  };

  renderMarkAsCompleteBtn = () => {
    const { isEditing } = this.props;

    if (!isEditing) {
      return null;
    }

    return (
      <Button
        color="success"
        type="button"
        onClick={(event) => this.handleCompletedSubmit(event)}
      >
        Save & Mark as Complete
      </Button>
    );
  };

  render() {
    const { formData, uiSchema, schema } = this.state;

    if (isEmpty(schema)) {
      return <Spin />;
    }

    return (
      <Form
        schema={schema}
        uiSchema={uiSchema}
        formData={formData}
        onChange={form => this.handleChange(form)}
        onSubmit={form => this.handleSubmit(form)}
      >
        <div>
          <button
            className="btn btn-primary"
            type="submit"
            ref={(btn) => {this.submitButton=btn;}}
          >
            Save
          </button>
          {this.renderMarkAsCompleteBtn()}
        </div>
      </Form>
    );
  };
};

StateFields.propTypes = propTypes;

export default StateFields;



// WEBPACK FOOTER //
// ./src/features/test/TestForm/StateFields.js